import QuoteStep from "../../enums/QuoteStep";
import useAppStateStore from "../../../../shared/store/AppStateStore";
import Drawer from "../../../../shared/components/Drawer";
import TqPanelUpdateForm from "./TqPanelUpdateForm";

const TqPanelUpdateModal = () => {
  const STATE = useAppStateStore();

  return (
    <Drawer
      isOpen={STATE.currentStep === QuoteStep.TQ_PANEL && STATE.showModel}
      onClose={() => STATE.setShowModel(false)}
      title="Customise your quote"
    >
      <TqPanelUpdateForm
        STATE={STATE}
        buttonSize="default"
        className="tw-flex tw-flex-col tw-gap-5"
        buttonGroupClassName="tw-flex tw-flex-col tw-gap-3"
      />
    </Drawer>
  );
};

export default TqPanelUpdateModal;
